// Pure scope filter shared by Deliverables and Milestones. Applied after
// the archive filter and BEFORE the SummaryStrip so strip counts describe
// the scoped surface the user is staring at (e.g. "3 milestones, 1
// overdue" for SOW-2026-001 — not the full contract). Chip + search
// filters layer on top after the strip.

import type { ScopeValue } from "./scopeTypes";

interface MaybeScoped {
  sowId?: string | null;
}

export function applyScopeFilter<T extends MaybeScoped>(
  items: readonly T[],
  scope: ScopeValue,
): T[] {
  if (scope.mode === "all") return [...items];
  if (scope.mode === "contract") {
    return items.filter((i) => i.sowId == null);
  }
  return items.filter((i) => i.sowId === scope.sowId);
}
